import $ from '@modules/jquery-import';
import Contenteditable from '@modules/ui/Contenteditable';

/**
 *  togglable
 *  adds toggle interaction to input fields hiding field and displaying value as plain text on blur
 */
$.fn.togglable = function () {
    var config = {
        wrapperClass: 'Togglable',
        fieldClass: 'Togglable-field',
        valueClass: 'Togglable-value'
    };

    return this.each( function () {
        // refactor
        var fields = $( this ).find( '[data-field-togglable]' );

        fields.each( function () {
            var $field = $( this ).addClass( config.fieldClass ),
                $valueField = Contenteditable.create(),
                $wrapper = $( '<span/>' ).addClass( config.wrapperClass ),
                classList = this.className.split( /\s+/ ),
                fieldClassIdx;

            // don't include orginal field class on editable fields
            if ( (fieldClassIdx = classList.indexOf( config.fieldClass )) > 0 ) {
                classList.splice( fieldClassIdx, 1 );
            }
            classList.push( config.valueClass );

            $valueField.$el.addClass( classList.join( ' ' ) );

            $field.on( 'validation:erroradded', function () {
                $valueField.$el.addClass( 'is-error' ).scrollToElement( {
                    offset: -($( '#header-outer' ).outerHeight() + 20)
                } );
            } );

            $valueField.setContents( $field.val() );
            $valueField.$el.on( 'contenteditable:changed', function ( e, data ) {
                $field.val( data.contents );
                var valid = $field.hasClass( 'required' )
                    ? $field.val() !== ''
                    : true;
                $valueField.$el.toggleClass( 'is-error', !valid )
            } );

            $wrapper = $field.wrap( $wrapper ).parent();

            if ( !$field.val() ) {
                $wrapper.addClass( config.editmodeClass );
            }

            $wrapper.prepend( $valueField.$el );
        } );
    } );
};
